// this is map of events that goes to amplitude and GTM
export default {
	getEvent(eventName: string): Record<string, string> | null {
		// Converts String to Object path and returns the accessed event
		try {
			return eventName.split('.').reduce((object: any, item) => object[item], this as any);
		} catch {
			return null;
		}
	},
	website_builder: {
		user_website: {
			forms: {
				form_enter: {
					amplitude: 'website_builder.user_website.forms.form_enter',
				},
			},
		},
		user_site: {
			add_to_cart_enter: {
				amplitude: 'website_builder.user_site.add_to_cart_enter',
			},
		},
	},
	builder_customers: {
		ecomm_checkout: {
			enter: {
				amplitude: 'builder_customers.ecomm_checkout.enter',
			},
		},
		ecomm: {
			order_successful: {
				amplitude: 'builder_customers.ecomm.order_successful',
			},
			order_failed: {
				amplitude: 'builder_customers.ecomm.order_failed',
			},
		},
	},
};
